/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    transactionId: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    pId?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    aC?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    householdName?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    portfolioName?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    cusip?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    isin?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    currencyPrimary: string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    subType?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    transactionDetail?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    assetDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    transferAccount?: string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    closePrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Transaction
     */
    isCashTransaction?: boolean;
}

/**
 * Check if a given object implements the Transaction interface.
 */
export function instanceOfTransaction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "transactionId" in value;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "currencyPrimary" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function TransactionFromJSON(json: any): Transaction {
    return TransactionFromJSONTyped(json, false);
}

export function TransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Transaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionId': json['transaction_id'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'pId': !exists(json, 'p_id') ? undefined : json['p_id'],
        'aC': !exists(json, 'a_c') ? undefined : json['a_c'],
        'householdName': !exists(json, 'household_name') ? undefined : json['household_name'],
        'portfolioName': !exists(json, 'portfolio_name') ? undefined : json['portfolio_name'],
        'cusip': !exists(json, 'cusip') ? undefined : json['cusip'],
        'tradeDate': json['trade_date'],
        'isin': !exists(json, 'isin') ? undefined : json['isin'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'currencyPrimary': json['currency_primary'],
        'amount': json['amount'],
        'type': json['type'],
        'subType': !exists(json, 'sub_type') ? undefined : json['sub_type'],
        'transactionDetail': !exists(json, 'transaction_detail') ? undefined : json['transaction_detail'],
        'assetDisplayName': !exists(json, 'asset_display_name') ? undefined : json['asset_display_name'],
        'transferAccount': !exists(json, 'transfer_account') ? undefined : json['transfer_account'],
        'quantity': json['quantity'],
        'closePrice': !exists(json, 'close_price') ? undefined : json['close_price'],
        'isCashTransaction': !exists(json, 'is_cash_transaction') ? undefined : json['is_cash_transaction'],
    };
}

export function TransactionToJSON(value?: Transaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction_id': value.transactionId,
        'portfolio_guid': value.portfolioGuid,
        'p_id': value.pId,
        'a_c': value.aC,
        'household_name': value.householdName,
        'portfolio_name': value.portfolioName,
        'cusip': value.cusip,
        'trade_date': value.tradeDate,
        'isin': value.isin,
        'symbol': value.symbol,
        'currency_primary': value.currencyPrimary,
        'amount': value.amount,
        'type': value.type,
        'sub_type': value.subType,
        'transaction_detail': value.transactionDetail,
        'asset_display_name': value.assetDisplayName,
        'transfer_account': value.transferAccount,
        'quantity': value.quantity,
        'close_price': value.closePrice,
        'is_cash_transaction': value.isCashTransaction,
    };
}

